import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Button } from '@ipc/ipc-components';
import moment from 'moment';
import {
  getLeftCheckedMailProcessingCenters,
  getRightCheckedMailProcessingCenters,
  getUserRole,
} from '../../../../common/user/redux/selectors/UserDataSelectors';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../common/tables/actions/ListTableActions';
import TableDefinitions from '../../../../common/TableDefinitions';
import ListTable from '../../../../common/tables/ListTable';
import {
  getColumns,
  getData,
  getIsLoading,
  getCheckedRows,
} from '../redux/selectors/ViewTransactionsPageSelectors';
import ViewTransactionsPageSelectionCriteriaContainer from './ViewTransactionsPageSelectionCriteriaContainer';
import PreAdviceTransactionsHistoryContainer
  from '../../../impc-stock-levels/transactions/transactions-history/pre-advice/containers/PreAdviceTransactionsHistoryContainer';
import PredesTransactionsHistoryContainer
  from '../../../impc-stock-levels/transactions/transactions-history/predes/containers/PredesTransactionsHistoryContainer';
import DownloadTypes from '../../../../common/tables/excel/DownloadTypes';
import RepatriationsTransactionsHistoryContainer
  from '../../../impc-stock-levels/transactions/transactions-history/repatriations/containers/RepatriationsTransactionsHistoryContainer';
import { postPredesTransactionsBulkReleaseRequestActionCreator } from '../../../impc-stock-levels/transactions/predes/release/redux/actions/PredesTransactionsReleaseActions';
import { postManualPreadviceTransactionsApplyRequestActionCreator } from '../../../impc-stock-levels/transactions/manual-preadvice/apply/redux/actions/ManualPreadviceTransactionsApplyActions';
import ManualPreadviceTransactionsDelete
  from '../../../impc-stock-levels/transactions/manual-preadvice/delete/containers/ManualPreadviceTransactionsDelete';
import { getGlobalEndDate, getGlobalStartDate } from '../../../../common/selection-criteria/period/redux/selectors/GlobalPeriodSelectionSelectors';
import { setGlobalEndDateSelectionActionCreator, setGlobalStartDateSelectionActionCreator } from '../../../../common/selection-criteria/period/redux/actions/GlobalPeriodSelectionActions';
import { postPredesTransactionsBulkRejectRequestActionCreator } from '../../../impc-stock-levels/transactions/predes/reject/redux/actions/PredesTransactionsRejectActions';

const leftTree = {
  title: 'Outbound Operators or IMPCs',
  roleFilter: false,
};
const rightTree = {
  title: 'Inbound Operators or IMPCs',
  roleFilter: true,
  useGlobalPresets: true,
};
const searchOptions = [
  { label: 'Generated from Predes', value: 'GFP' },
  { label: 'Manual Pre-Advice', value: 'MPA' },
  { label: 'Internal Repatriation', value: 'IRO' },
  { label: 'Center Initiated Repatriation', value: 'CRO' },
];

const manualPreadviceStatusOptions = [
    { label: 'Saved', value: 'SAVED' },
    { label: 'Open', value: 'OPEN' },
    { label: 'Serviced Out', value: 'SERVICED_OUT' },
    { label: 'Serviced In', value: 'SERVICED_IN' },
    { label: 'Deleted', value: 'DELETED' },
  ];

const repatriationsSearchOptions = [
    { label: 'All', value: null },
    { label: 'Open', value: 'OPEN' },
    { label: 'Executed', value: 'EXECUTED' },
    { label: 'Serviced Out', value: 'SERVICED_OUT' },
    { label: 'Serviced In', value: 'SERVICED_IN' },
    { label: 'Confirmed', value: 'CONFIRMED' },
    { label: 'Deleted', value: 'DELETED' },
  ];

const predesSearchOptions = [
    { label: 'Open', value: 'OPEN' },
    { label: 'Serviced Out', value: 'SERVICED_OUT' },
    { label: 'Serviced In', value: 'SERVICED_IN' },
    { label: 'On Hold', value: 'ON_HOLD' },
    { label: 'On Hold Rejected', value: 'ON_HOLD_REJECTED' },
    { label: 'Deleted', value: 'DELETED' },
  ];

class ViewTransactionsPageContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      selectedStartDate: this.props.globalStartDate,
      selectedEndDate: this.props.globalEndDate,
      statusOptions: [
        { label: 'Open', value: 'OPEN' },
        { label: 'Serviced Out', value: 'SERVICED_OUT' },
        { label: 'Serviced In', value: 'SERVICED_IN' },
        { label: 'On Hold', value: 'ON_HOLD' },
        { label: 'On Hold Rejected', value: 'ON_HOLD_REJECTED' },
        { label: 'Deleted', value: 'DELETED' },
      ],
      transactionStatus: { label: 'Open', value: 'OPEN' },
      transactionType: 'GFP',
      showDeleteModal: false,
    };
    this.applyBulkRelease = this.applyBulkRelease.bind(this);
    this.applyBulkReject = this.applyBulkReject.bind(this);
    this.bulkApplySavedStatusToOpen = this.bulkApplySavedStatusToOpen.bind(this);
    this.deleteTransaction = this.deleteTransaction.bind(this);
  }

  showDeleteFormModal = () => {
    this.setState({
      showDeleteModal: true,
    });
  }

  hideDeleteFormModal = () => {
    this.setState({
      showDeleteModal: false,
    });
  }

  onStartDateChange = (newDate) => {
    if ((this.state.transactionType === 'IRO' || this.state.transactionType === 'CRO') && this.state.transactionStatus === { label: 'All', value: null }) {
      if (moment(this.state.selectedEndDate).diff(moment(new Date(newDate)), 'days') <= 30) {
        this.setState({
          selectedStartDate: newDate,
        });
      } else {
        this.setState({
          selectedStartDate: newDate,
          selectedEndDate: moment(new Date(newDate)).add(1, 'month').format('YYYY-MM-DD'),
        });
        this.props.setGlobalEndDateSelectionActionCreator(moment(new Date(newDate)).add(1, 'month'));
      }
    } else {
      this.setState({
        selectedStartDate: newDate,
      });
    }
    this.props.setGlobalStartDateSelectionActionCreator(newDate);
  }

  onEndDateChange = (newDate) => {
    this.setState({
      selectedEndDate: newDate,
    });
    this.props.setGlobalEndDateSelectionActionCreator(newDate);
  }

  onTransactionTypeChange = (selectedOption) => {
    switch (selectedOption.value) {
    case 'MPA':
      this.setState({
        statusOptions: manualPreadviceStatusOptions,
        transactionStatus: { value: 'Select...', label: 'Select...' },
      });
      break;
    case 'IRO':
      this.setState({
        statusOptions: repatriationsSearchOptions,
        transactionStatus: { value: 'Select...', label: 'Select...' },
      });
      break;
    case 'CRO':
      this.setState({
        statusOptions: repatriationsSearchOptions,
        transactionStatus: { value: 'Select...', label: 'Select...' },
      });
      break;
    case 'GFP':
      this.setState({
        statusOptions: predesSearchOptions,
        transactionStatus: { value: 'Select...', label: 'Select...' },
      });
      break;
    default:
      return this.state.statusOptions;
    }
    this.setState({
      transactionType: selectedOption.value,
    });
  }

  onStatusChange = (selectedOption) => {
    if ((this.state.transactionType === 'IRO' || this.state.transactionType === 'CRO') && selectedOption.label === 'All') {
      this.setState({
        selectedStartDate: moment(this.props.globalEndDate).subtract(1, 'month').format('YYYY-MM-DD'),
        selectedEndDate: moment(this.props.globalEndDate).format('YYYY-MM-DD'),
        transactionStatus: selectedOption,
        areDatesDisabled: this.areDatesDisabled(selectedOption.value),
      });
    } else {
      this.setState({
        transactionStatus: selectedOption,
        areDatesDisabled: this.areDatesDisabled(selectedOption.value),
      });
    }
  }

  areDatesDisabled = (transactionStatus) => (this.state.transactionType === 'GFP' && transactionStatus === 'ON_HOLD')
      || (this.state.transactionType === 'GFP' && transactionStatus === 'ON_HOLD_REJECTED')
      || (this.state.transactionType === 'MPA' && transactionStatus === 'SAVED')
      || (this.state.transactionType === 'IRO' && transactionStatus === 'OPEN')
      || (this.state.transactionType === 'CRO' && transactionStatus === 'OPEN');

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });

    if (this.state.areDatesDisabled) {
      this.props.tableLoadData(
        { tableId: 'TRANSACTION_MANAGEMENT' },
        this.props.appContext.appContext,
        {
          endDate: null,
          fromImpcs: this.props.leftCheckedMailProcessingCenters,
          status: this.state.transactionStatus.value,
          startDate: null,
          toImpcs: this.props.rightCheckedMailProcessingCenters,
          transactionTypeCode: this.state.transactionType,
        },
      );
    } else {
      this.props.tableLoadData(
        { tableId: 'TRANSACTION_MANAGEMENT' },
        this.props.appContext.appContext,
        {
          endDate: this.state.selectedEndDate,
          fromImpcs: this.props.leftCheckedMailProcessingCenters,
          status: this.state.transactionStatus.value,
          startDate: this.state.selectedStartDate,
          toImpcs: this.props.rightCheckedMailProcessingCenters,
          transactionTypeCode: this.state.transactionType,
        },
      );
    }
  };

  async applyBulkRelease() {
    const transactionIds = [];
    this.props.checkedRows.map((index) => (index.status === 'ON_HOLD' && index.arrivalDate !== null ? transactionIds.push(index.id) : transactionIds));
    await this.props.postPredesTransactionsBulkReleaseRequestActionCreator(
      this.props.appContext,
      transactionIds,
    );
    this.onCriteriaApply();
  }

  async applyBulkReject() {
    const transactionIds = [];
    this.props.checkedRows.map((index) => (index.status === 'ON_HOLD' ? transactionIds.push(index.id) : transactionIds));
    await this.props.postPredesTransactionsBulkRejectRequestActionCreator(
      this.props.appContext,
      transactionIds,
    );
    this.onCriteriaApply();
  }

  async bulkApplySavedStatusToOpen() {
    const transactionIds = [];
    this.props.checkedRows.map((index) => (index.status === 'SAVED' ? transactionIds.push(index.id) : transactionIds));
    await this.props.postManualPreadviceTransactionsApplyRequestActionCreator(
      this.props.appContext,
      transactionIds,
    );
    this.onCriteriaApply();
  }

  deleteTransaction() {
    this.setState({
      showDeleteModal: true,
    });
  }

  render() {
    const { isLoading, data, columns } = this.props;
    const {
      showResult,
      selectedStartDate,
      selectedEndDate,
      statusOptions,
      transactionType,
      showDeleteModal,
      areDatesDisabled,
      transactionStatus,
    } = this.state;

    return (
      <div>
        <ViewTransactionsPageSelectionCriteriaContainer
          open={data.length === 0}
          title="View Transactions"
          onApply={this.onCriteriaApply}
          selectedStartDate={selectedStartDate}
          onStartDateChange={this.onStartDateChange}
          selectedEndDate={selectedEndDate}
          onEndDateChange={this.onEndDateChange}
          areDatesDisabled={areDatesDisabled}
          searchOptions={searchOptions}
          statusOptions={statusOptions}
          transactionStatus={transactionStatus}
          onTransactionTypeChange={this.onTransactionTypeChange}
          onStatusChange={this.onStatusChange}
          leftTree={leftTree}
          rightTree={rightTree}
          switchEnabled
        />
        <div className="general-content-container">
          {(showResult || data.length > 0) && (
            <div className="full-width">
              <div className="list-table-container" style={{ paddingBottom: '20px', minHeight: '740px' }}>
                {transactionType === 'MPA' && (
                  <div>
                    <div className="view-transacitons-bulk-actions">
                      {this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0 && this.props.checkedRows.filter((index) => (index.status === 'SAVED')).length !== 0
                      && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
                        || this.props.userRole.includes('IPC_TRAY_MANAGER')
                        || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
                        <Button className="action-buttons primary-button-false" onClick={this.bulkApplySavedStatusToOpen}>
                          APPLY
                        </Button>
                      )}
                      {this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0 && (this.props.checkedRows.filter((index) => (index.status === 'SAVED')).length !== 0
                        || this.props.checkedRows.filter((index) => (index.status === 'OPEN')).length !== 0
                        || this.props.checkedRows.filter((index) => (index.status === 'SERVICED_IN')).length !== 0
                        || this.props.checkedRows.filter((index) => (index.status === 'SERVICED_OUT')).length !== 0)
                      && (this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
                        || this.props.userRole.includes('IPC_TRAY_MANAGER')
                        || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
                        <Button className="action-buttons primary-button-false" onClick={this.deleteTransaction}>
                          DELETE
                        </Button>
                      )}
                    </div>
                    <ListTable
                      listId={TableDefinitions.TRANSACTION_MANAGEMENT.id}
                      loading={isLoading}
                      columns={this.props.columns}
                      data={this.props.data}
                      keyField="id"
                      selectCheckbox
                      pagination
                      downloadType={DownloadTypes.EXCEL}
                      getSubComponentProps={(row) => (
                        <div style={{ padding: '20px' }}>
                          <PreAdviceTransactionsHistoryContainer
                            row={row}
                            refreshTransactions={this.onCriteriaApply}
                          />
                        </div>
                      )}
                    />
                    {showDeleteModal && (
                      <ManualPreadviceTransactionsDelete
                        closeDialog={this.hideDeleteFormModal}
                        openDialog={this.showDeleteFormModal}
                        row={this.props.checkedRows}
                      />
                    )}
                  </div>
                )}
                {transactionType === 'GFP' && (
                  <div>
                    <div className="view-transacitons-bulk-actions">
                      {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
                        || this.props.userRole.includes('IPC_TRAY_MANAGER')
                        || this.props.userRole.includes('IPC_BAG_MANAGER'))
                      && (this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0
                        && this.props.checkedRows.filter((index) => (index.status === 'ON_HOLD' && index.arrivalDate !== null)).length !== 0) && (
                        <Button className="action-buttons primary-button-false" onClick={this.applyBulkRelease}>
                          RELEASE
                        </Button>
                      )}
                      {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
                        || this.props.userRole.includes('IPC_TRAY_MANAGER')
                        || this.props.userRole.includes('IPC_BAG_MANAGER'))
                      && (this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0 && this.props.checkedRows.filter((index) => (index.status === 'ON_HOLD')).length !== 0) && (
                        <Button className="action-buttons primary-button-false" onClick={this.applyBulkReject}>
                          REJECT
                        </Button>
                      )}
                    </div>
                    <ListTable
                      listId={TableDefinitions.TRANSACTION_MANAGEMENT.id}
                      columns={this.props.columns}
                      data={this.props.data}
                      loading={isLoading}
                      keyField="id"
                      selectCheckbox
                      pagination
                      downloadType={DownloadTypes.EXCEL}
                      getSubComponentProps={(row) => (
                        <div style={{ padding: '20px' }}>
                          <PredesTransactionsHistoryContainer
                            row={row}
                            refreshTransactions={this.onCriteriaApply}
                          />
                        </div>
                      )}
                    />
                  </div>
                )}
                {(transactionType === 'IRO' || transactionType === 'CRO') && (
                  <div>
                    <ListTable
                      listId={TableDefinitions.TRANSACTION_MANAGEMENT.id}
                      columns={columns}
                      data={data}
                      loading={isLoading}
                      keyField="id"
                      selectCheckbox
                      pagination
                      downloadType={DownloadTypes.EXCEL}
                      getSubComponentProps={(row) => (
                        <div style={{ padding: '20px' }}>
                          <RepatriationsTransactionsHistoryContainer
                            row={row}
                            refreshTransactions={this.onCriteriaApply}
                          />
                        </div>
                      )}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

ViewTransactionsPageContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  leftCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  rightCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  isLoading: PropTypes.bool,
  checkedRows: PropTypes.arrayOf(PropTypes.object),
  postPredesTransactionsBulkReleaseRequestActionCreator: PropTypes.func,
  postPredesTransactionsBulkRejectRequestActionCreator: PropTypes.func,
  postManualPreadviceTransactionsApplyRequestActionCreator: PropTypes.func,
  userRole: PropTypes.arrayOf(PropTypes.string),
  globalStartDate: PropTypes.instanceOf(Date),
  globalEndDate: PropTypes.instanceOf(Date),
  setGlobalStartDateSelectionActionCreator: PropTypes.func,
  setGlobalEndDateSelectionActionCreator: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    isLoading: getIsLoading(state),
    leftCheckedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    rightCheckedMailProcessingCenters: getRightCheckedMailProcessingCenters(state),
    appContext: getAssetType(state),
    checkedRows: getCheckedRows(state),
    userRole: getUserRole(state),
    globalStartDate: getGlobalStartDate(state),
    globalEndDate: getGlobalEndDate(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  postPredesTransactionsBulkReleaseRequestActionCreator,
  postManualPreadviceTransactionsApplyRequestActionCreator,
  postPredesTransactionsBulkRejectRequestActionCreator,
  setGlobalStartDateSelectionActionCreator,
  setGlobalEndDateSelectionActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ViewTransactionsPageContainer);
